import { useEffect } from "react";

const SITE_NAME = "AlumniPulse";

// useSeo(title, description, image, options)
// options: { canonical, noindex, type, jsonLd }
export function useSeo(title, description, image, options = {}) {
  const { canonical, noindex = false, type = "website", jsonLd = null } = options;
  useEffect(() => {
    if (title) document.title = `${title} · ${SITE_NAME}`;

    const setMeta = (attr, key, val) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (val == null) { if (el) el.remove(); return; }
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
      el.setAttribute("content", val);
    };
    const setLink = (rel, href) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!href) { if (el) el.remove(); return; }
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
      el.setAttribute("href", href);
    };

    const url = typeof window !== "undefined"
      ? (canonical || window.location.origin + window.location.pathname)
      : canonical;
    const fullTitle = title ? `${title} · ${SITE_NAME}` : SITE_NAME;

    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");

    setMeta("property", "og:site_name", SITE_NAME);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", image || null);

    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image || null);

    setLink("canonical", url);

    // JSON-LD structured data (Organization / Article / Event / etc.)
    let ld = document.getElementById("seo-jsonld");
    if (jsonLd) {
      if (!ld) { ld = document.createElement("script"); ld.id = "seo-jsonld"; ld.type = "application/ld+json"; document.head.appendChild(ld); }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) { ld.remove(); }

    return () => {
      document.title = SITE_NAME;
      const r = document.querySelector('meta[name="robots"]');
      if (r) r.setAttribute("content", "index, follow");
      const l = document.getElementById("seo-jsonld");
      if (l) l.remove();
    };
  }, [title, description, image, canonical, noindex, type, jsonLd]);
}
